import Captcha from "./Captcha";
import { RateStarInput } from "./Rate";

import { useState } from "react";

import { Alert, Button, FloatingLabel, Form, FormControl, FormLabel } from "react-bootstrap";
import { useForm } from "react-hook-form";

import { createReview } from "../../api/internal";
import { reviewFormSchema } from "../../api/schema/validation";

const { yupResolver } = require("@hookform/resolvers/yup");

export const ReviewForm = ({ productId }) => {
  const [success, setSuccess] = useState(false);

  const {
    register,
    handleSubmit,
    control,
    setError,
    reset,
    formState: { errors },
  } = useForm({ resolver: yupResolver(reviewFormSchema) });
  const onSubmit = async (data) => {
    const { success, errors } = await createReview({ productId, ...data });
    if (errors) {
      Object.entries(errors).map(([field, message]) => {
        setError(field, { type: "manual", message });
      });
      return;
    }

    if (success) {
      setSuccess(true);
      reset();
    }
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      {success && (
        <Alert variant="success">
          Twoja opinia została wysłana! Bardzo Teraz trafi do moderatora i po akceptacji będzie
          pomocna dla innych klientów. Dziękujemy!
        </Alert>
      )}
      <Form.Group className="mb-3">
        <FormLabel>Twoja ocena</FormLabel>
        <RateStarInput name="rating" control={control} />
        <Form.Control.Feedback type="invalid">{errors.rating?.message}</Form.Control.Feedback>
      </Form.Group>

      <FloatingLabel className="mb-3" label="Wyświetlana nazwa">
        <FormControl {...register("name")} isInvalid={!!errors.name} />
        <Form.Control.Feedback type="invalid">{errors.name?.message}</Form.Control.Feedback>
      </FloatingLabel>

      <FloatingLabel className="mb-3" label="Adres email do weryfikacji (nigdzie nie wyświetlany)">
        <FormControl {...register("email")} isInvalid={!!errors.email} />
        <Form.Control.Feedback type="invalid">{errors.email?.message}</Form.Control.Feedback>
      </FloatingLabel>

      <FloatingLabel className="mb-3" label="Treść opinii">
        <FormControl as="textarea" isInvalid={!!errors.content} {...register("content")} />
        <Form.Control.Feedback type="invalid">{errors.content?.message}</Form.Control.Feedback>
      </FloatingLabel>

      <Form.Group className="mb-3">
        <Captcha name="recaptcha" control={control} />
        <Form.Control.Feedback type="invalid">{errors.recaptcha?.message}</Form.Control.Feedback>
      </Form.Group>

      <Button type="submit">Dodaj opinię</Button>
    </Form>
  );
};
